<template>
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0840001 0.684H4.692L12.052 7.948L4.692 15.212H0.0840001L7.476 7.948L0.0840001 0.684Z"
      fill="#888b8d"
    />
  </svg>
</template>
